<div class="bullet-state-container">

  <!-- <mat-icon class="bullet-state" [class]="configuration?.state">circle</mat-icon> -->
  <span class="m-l-5 bullet-state" [class]="configuration?.state">{{ (configuration?.state) | translate }}</span>

</div>
